import { MutationTree } from 'vuex'

import type { TechpackState, UITechpackModel } from './techpack.types'

export enum MutationTypes {
  SET_LOADING = 'SET_LOADING',
  SET_ERROR_STATE = 'SET_ERROR_STATE',
  SET_TECHPACK_STATE = 'SET_TECHPACK_STATE'
}

export const mutations: MutationTree<TechpackState> = {
  [MutationTypes.SET_LOADING](state, loadingState: boolean) {
    state.loading = loadingState
  },
  [MutationTypes.SET_ERROR_STATE](state, errorMessage: string) {
    state.errorMessage = errorMessage
  },
  [MutationTypes.SET_TECHPACK_STATE](state, techpack: UITechpackModel) {
    state.techpack = techpack
  }
}
